var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2255_26742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1292 8.3651C15.5625 5.49844 13.0333 3.33594 10 3.33594C7.59167 3.33594 5.50833 4.7026 4.4625 6.69844C1.95417 6.9651 0 9.0901 0 11.6693C0 14.4318 2.2375 16.6693 5 16.6693H15.8333C18.1333 16.6693 20 14.8026 20 12.5026C20 10.3026 18.2917 8.51927 16.1292 8.3651ZM15.8333 15.0026H5C3.1625 15.0026 1.66667 13.5068 1.66667 11.6693C1.66667 9.83177 3.1625 8.33594 5 8.33594C6.8375 8.33594 8.33333 9.83177 8.33333 11.6693H10C10 9.36927 8.44583 7.4401 6.33333 6.85677C7.17083 5.73594 8.5 5.0026 10 5.0026C12.5292 5.0026 14.5833 7.05677 14.5833 9.58594V10.0026H15.8333C17.2125 10.0026 18.3333 11.1234 18.3333 12.5026C18.3333 13.8818 17.2125 15.0026 15.8333 15.0026Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2255_26742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIcon);
export default __webpack_public_path__ + "static/media/cloud-icon.0f1183dab09b213db208b1657d8c47b5.svg";
export { ForwardRef as ReactComponent };